// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-dialog-container {
  padding: 0 24px 24px 24px !important;
}

.cdk-overlay-pane {
  background-color: #F6F9FC !important;
}

input {
  padding: 4px 2px 4px 10px;
  outline: unset;
}

.modal-bank-account {
  height: auto;
  width: auto;
}

.bank-header {
  width: 100%;
  position: relative;
  text-align: center;
  padding: 6px 0 30px 0;
}

.bank-body {
  width: 100%;
  position: relative;
}

.bank-form {
  width: 100%;
  position: relative;
}

.bank-form button {
  width: 100%;
  border-radius: 0;
}

.names {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.names > div {
  width: 45%;
  position: relative;
  display: flex;
}

.names > div input {
  width: 100%;
  margin-bottom: 30px;
}

.names mat-error {
  position: absolute;
  bottom: 3px;
}

mat-error {
  height: 14px;
  font-size: 14px;
  padding-left: 4px;
}

.number {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.error-margin {
  margin-top: 5px;
  margin-bottom: 30px;
}

.number input {
  width: calc(100% - 22px);
  margin-right: 6px;
}

.bank-input-group {
  display: flex;
  flex-direction: row;
}

mat-form-field {
  margin-bottom: 20px;
}

.info-icons {
  position: relative;
  cursor: pointer;
}

.info-icons:nth-child(1):after {
  content: "";
  width: 300px;
  position: absolute;
  right: 0;
  transform: translateX(100%);
  background-image: url('logo.png');
}`, "",{"version":3,"sources":["webpack://./src/app/dialog/stripe-ach-payment/stripe-ach-payment.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;AACF","sourcesContent":[".mat-mdc-dialog-container {\n  padding: 0 24px 24px 24px !important;\n}\n\n.cdk-overlay-pane {\n  background-color: #F6F9FC !important;\n}\n\ninput {\n  padding: 4px 2px 4px 10px;\n  outline: unset;\n}\n\n.modal-bank-account {\n  height: auto;\n  width: auto;\n}\n\n.bank-header {\n  width: 100%;\n  position: relative;\n  text-align: center;\n  padding: 6px 0 30px 0;\n}\n\n.bank-body {\n  width: 100%;\n  position: relative;\n}\n\n.bank-form {\n  width: 100%;\n  position: relative;\n}\n\n.bank-form button {\n  width: 100%;\n  border-radius: 0;\n}\n\n.names {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.names > div {\n  width: 45%;\n  position: relative;\n  display: flex;\n}\n\n.names > div input {\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.names mat-error {\n  position: absolute;\n  bottom: 3px;\n}\n\nmat-error {\n  height: 14px;\n  font-size: 14px;\n  padding-left: 4px;\n}\n\n.number {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.error-margin {\n  margin-top: 5px;\n  margin-bottom: 30px;\n}\n\n.number input {\n  width: calc(100% - 22px);\n  margin-right: 6px;\n}\n\n.bank-input-group {\n  display: flex;\n  flex-direction: row;\n}\n\nmat-form-field {\n  margin-bottom: 20px;\n}\n\n.info-icons {\n  position: relative;\n  cursor: pointer;\n}\n\n.info-icons:nth-child(1):after {\n  content: '';\n  width: 300px;\n  position: absolute;\n  right: 0;\n  transform: translateX(100%);\n  background-image: url(\"../../../assets/images/logo.png\");\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
